import { connect } from 'react-redux'

var RosterActions = require("lib/actions/RosterActions");
var ErrorDisplay = require("components/utility/ErrorDisplay")
var LoadingButton = require("components/utility/LoadingButton");
var Spinner = require("components/utility/Spinner")
var CurrentUser = require("lib/account/CurrentUser");
var WhooosReadingServices = require("lib/web/WhooosReadingServices");

require("users/teachers/upgrade/upgrade_token_form.scss");

@connect(
	() => ({}),

	(dispatch, props) => ({
		onSubmit: (upgradeCode) => {
			var currentUserID = CurrentUser.get().id;

			return dispatch(RosterActions.updateAdmin({
				id: currentUserID,
				update: { account: { upgrade_code: upgradeCode } }
			}))
		},
		updateReferral: (referralCode) => {
			var currentUserID = CurrentUser.get().id;

			return dispatch(RosterActions.updateAdmin({
				id: currentUserID,
				update: { referred_by: referralCode, features: 'wrGold' } 
			}))
		}
	})
)
class UpgradeTokenForm extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		this.state = {
			upgraded: false,
			showUpgradeCode: !props.requireToggle, upgradeCode: "", loading: false, referral: false
		};

		this.errors = React.createRef();
		this.field = React.createRef();
	}

	toggleUpgradeCode(e) {
		$wr.nope(e);
		this.setState({ showUpgradeCode: !this.state.showUpgradeCode }, () => {
			$(this.field.current).focus();
		});
	}
	// display valid referral message
	validReferralCode() {
		Mycroft.newEvent({ category: "Referrals", action: "onboarding-modal-referral" });
		this.setState({ referral: true })
		window.wrNotifications.triggerDropDownNotification({ title: "Referral submitted successfully!", icon: "ok-sign" })
		window.location.reload();
	}

	submitUpgradeOrReferralCode() {
		this.errors.current.reset();

		var code = this.state.upgradeCode.trim().toUpperCase();
		if (code.length == 0) {
			var errorText = "Enter an 8-digit upgrade code"
			this.errors.current.setError(errorText)
		} else if (code.length == 9 && !this.state.referral) {
			// test if referral code exists code
			// user can't submit 2 referral codes
			this.setState({ loading: true });
			this.props.updateReferral(this.state.upgradeCode.trim()).then((response) => {
				var errors = response.admins[0].errors;
				this.setState({ loading: false });
				// display error or render success banner
				if (_.any(errors)) {
					this.errors.current.setErrors(errors);
				} else {
					this.validReferralCode();
				}
			});

		} else {
			this.setState({ loading: true });
			this.props.onSubmit(code).then((response) => {
				var errors = response.admins[0].errors;

				if (_.any(errors)) {
					this.errors.current.setErrors(errors);
					this.setState({ loading: false });
				} else {
					window.wrNotifications.triggerDropDownNotification({
						title: "Matched!", icon: "ok-sign",
						text: "We found your code and are activating your account.", 
					});

					CurrentUser.fetchCurrentUserData(() => {
						if (this.props.updateInPlace) {
							this.setState({ loading: false, upgradeCode: "", upgraded: true });
						} else {
							if (this.props.requireToggle) {
								this.setState({ loading: false, upgradeCode: "", showUpgradeCode: false });
							} else {
								this.setState({ loading: false, upgradeCode: "" });
							}
							$wr.redirect("/");							
						}
					});

				}
			});
		}
	}

	onKeyDown(e) {
		if ((e.keyCode == 13) && !this.state.loading) {
			$wr.nope(e)
			this.submitUpgradeOrReferralCode();
		}
	}

	render() {
		if (this.state.upgraded) {
			return (
				<div className="upgradeTokenForm">
					Upgraded!
				</div>
			)
		} else if (this.state.showUpgradeCode) {
			if (this.state.loading) {
				var button = (
					<Spinner placeholder scale={ 0.8 } />
				)
			} else {
				if (this.props.showCompleteButton) {
					var submitText = "Complete Upgrade"
					var button = (
						<LoadingButton className="btn buttonSuccess"
							onClick={ this.submitUpgradeOrReferralCode } text={ submitText }
							loading={ !!(this.state.loading || this.props.loadingStudentLists) } />
					);
					var buttonArea = (
						<div className="buttonArea">{ button }</div>
					)
				} else if (this.state.upgradeCode) {
					var buttonArea = (
						<button className="btn btn-link" onClick={ this.submitUpgradeOrReferralCode }>
							Save
						</button>
					);
				}
			}

			return (
				<div className="upgradeTokenForm">
					<ErrorDisplay ref={ this.errors } />
					<div className="codeField">
						<input className="form-control" value={ this.state.upgradeCode }
							onKeyDown={ this.onKeyDown }
							placeholder="Code goes here" ref={ this.field }

							onChange={ (e) => this.setState({ upgradeCode: e.target.value }) } />
					</div>
					{ buttonArea }
				</div>
			);
		} else {
			return (
				<div className="upgradeTokenForm">
					<a href="#" onClick={ this.toggleUpgradeCode }>Have an activation code?</a>
				</div>
			);
		}
	}
}

UpgradeTokenForm.WrappedComponent.propTypes = StrictPropTypes({
	// From @connect
	onSubmit: PropTypes.func,
	updateReferral: PropTypes.func,

	requireToggle: PropTypes.bool,
	updateInPlace: PropTypes.bool

});

module.exports = UpgradeTokenForm;



// WEBPACK FOOTER //
// ./modules/components/users/teachers/upgrade/UpgradeTokenForm.js